import { render, staticRenderFns } from "./TransacoesAvulsa.vue?vue&type=template&id=5fd82f42&"
import script from "./TransacoesAvulsa.vue?vue&type=script&lang=js&"
export * from "./TransacoesAvulsa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports